import numeral from 'numeral';

export const inputNumberFormatter = (value) => numeral(value).format('0,0');
export const inputNumberParser = (value) => numeral(value).value();
